import { Link } from "react-router-dom";
import { usePageMeta, useJsonLd } from "../../hooks/useSeo";
import { Breadcrumbs } from "../../components/base/NewsCard";

const positioning = [
  {
    icon: "ri-flashlight-line",
    title: "首发追踪",
    desc: "对娱乐圈、网红圈的一手动态保持高敏感度，看到苗头就深挖，让你不错过任何重要节点。",
  },
  {
    icon: "ri-search-eye-line",
    title: "客观还原",
    desc: "面对喧嚣与争议，我们更愿意回到事实本身，把来龙去脉讲清楚，少一点情绪，多一点分寸。",
  },
  {
    icon: "ri-user-voice-line",
    title: "多元视角",
    desc: "不止围观热闹，也关注内容生态、行业规则与普通创作者，为从业者和爱好者提供参考。",
  },
];

const values = [
  "尊重事实：坚持多重信源核实，不造谣、不传谣，避免片面采信。",
  "把握分寸：涉及个人隐私与未成年人时格外审慎，不为流量越过底线。",
  "克制表达：标题可以吸引人，但内容必须经得起推敲，不靠断章取义博眼球。",
  "持续陪伴：把每一次更新当作与读者的长期约定，稳定输出、日拱一卒。",
];

const quotes = [
  {
    name: "阿泽 · 追剧达人",
    text: "本来只是随手刷到，结果每篇都看得下去。不标题党，结尾还真的有信息量，已收藏成固定栏目。",
  },
  {
    name: "Momo · 内容从业者",
    text: "关于直播电商和红人合约那几篇写得很实在，看得出是真做过功课的编辑，推荐给同行。",
  },
  {
    name: "小北 · 大学生",
    text: "以前总在各种群里吃二手瓜，现在直接来这看原委，省心多了。",
  },
];

export default function About() {
  usePageMeta({
    title: "关于我们 - 每日爆料网 品牌介绍与内容定位",
    description:
      "了解每日爆料网：品牌介绍、内容定位、发展理念与报道原则。我们专注娱乐圈与网红圈资讯，坚持客观、有料、有分寸的编辑立场。",
  });

  useJsonLd("about", {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于每日爆料网",
    url: "https://29nx.cn/about",
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: "每日爆料网" },
  });

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      {/* 页头 */}
      <section className="rounded-2xl bg-secondary-800 p-8 text-background-50 md:p-12">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-400 px-3 py-1 text-xs font-bold text-secondary-900">
          <i className="ri-news-line" /> 关于每日爆料网
        </span>
        <h1 className="mt-4 max-w-3xl font-serif text-3xl font-black leading-snug md:text-5xl">
          我们做的是「快而真」的
          <span className="text-accent-300">娱乐资讯</span>
        </h1>
        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-background-100/90">
          大家好，这里是每日爆料网。我们是一支专注娱乐圈与网红圈的内容团队。在信息爆炸、人人都在抢速度的年代，我们选择用「不偷懒」的方式做报道——既要快人一步，也要对得起每一位点进来的你。
        </p>
      </section>

      {/* 定位 */}
      <section className="mt-12">
        <h2 className="font-serif text-2xl font-black text-foreground-950">我们的内容定位</h2>
        <p className="mt-2 max-w-2xl text-[15px] text-foreground-700">
          热点千千万，我们只做三件事：追得上的首发、讲得清的内幕、留得住的内容。
        </p>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {positioning.map((p) => (
            <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${p.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 发展理念 */}
      <section id="fazhan" className="mt-14 scroll-mt-24 border-t border-background-300/60 pt-10">
        <div className="grid grid-cols-1 items-start gap-10 md:grid-cols-2">
          <div>
            <h2 className="font-serif text-2xl font-black text-foreground-950">发展理念</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              从最初几个人在群里分享圈内观察，到逐步沉淀出栏目与报道标准，我们始终相信：内容行业的护城河不在流量，而在「信任」。速度可以吸引第一次点进来的人，但只有扎实与真诚，才能留住长期关注的你。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              我们不追求每一篇都「爆」，但希望每一篇都「值得」。未来我们会稳步拓展独家调查、行业深度与创作者访谈等方向，让这块内容阵地越来越完整。
            </p>
            <Link
              to="/category/dujia"
              className="mt-6 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看看我们的独家栏目 <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="overflow-hidden rounded-xl">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20newsroom%20team%20brainstorming%20around%20laptop%20with%20coffee%20and%20notes%20on%20warm%20wooden%20table%2C%20warm%20natural%20window%20light%2C%20cozy%20authentic%20content%20studio%20atmosphere%2C%20photography&width=1200&height=800&seq=about-office-01&orientation=portrait"
              alt="每日爆料网编辑部日常工作场景"
              title="每日爆料网编辑部"
              className="aspect-[3/2] w-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* 内容原则 */}
      <section id="yuanze" className="mt-14 scroll-mt-24 border-t border-background-300/60 bg-background-50 pt-10">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-serif text-2xl font-black text-foreground-950">我们坚守的内容原则</h2>
          <p className="mt-2 text-foreground-600">这四条底线，是每篇内容上线前都要过的关。</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v, i) => (
              <div key={i} className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-100 p-5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-400 font-serif text-base font-black text-secondary-900">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-[15px] leading-relaxed text-foreground-800">{v}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 口碑 */}
      <section className="mt-14">
        <h2 className="font-serif text-2xl font-black text-foreground-950">读者怎么说</h2>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {quotes.map((q) => (
            <figure key={q.name} className="rounded-xl border border-background-200 bg-background-50 p-6">
              <div className="flex gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-800">“{q.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 text-sm">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-bold text-secondary-900">
                  {q.name.slice(0, 1)}
                </span>
                <span className="font-medium text-foreground-900">{q.name}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系 */}
      <section className="mt-14 rounded-2xl bg-primary-600 p-8 text-center text-background-50 md:p-12">
        <i className="ri-chat-smile-3-line text-4xl text-accent-300" />
        <h2 className="mt-4 font-serif text-2xl font-black md:text-3xl">想跟我们聊聊，或投个独家线索？</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-background-100/90">
          无论是选题建议、事实反馈还是第一手线索，欢迎通过投稿与联系页面告诉我们。你的来信，我们都会认真对待。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/faq#tougao" className="cursor-pointer whitespace-nowrap rounded-md bg-accent-400 px-5 py-2.5 text-sm font-bold text-secondary-900 transition-colors hover:bg-accent-300">
            去投稿
          </Link>
          <Link to="/faq#contact" className="cursor-pointer whitespace-nowrap rounded-md bg-background-50/15 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/25">
            联系我们
          </Link>
        </div>
      </section>
    </div>
  );
}